// biome-ignore lint/correctness/noUnusedVariables: This is probably used somewhere?
function ScrollBar(
  /** @type {Splide.Splide} */ Splide,
  /** @type {Splide.Components} */ Components,
  /** @type {Splide.Options} */ options,
) {
  const { track } = Components.Elements;
  /** @type {HTMLDivElement | null} */
  let scrollWrapper = null;
  const splideList = track.querySelector("ul");

  function mount() {
    const splideWrapper = track.parentElement;
    /** @type {HTMLElement[]} */
    const ctas =
      splideWrapper === null
        ? []
        : Array.prototype.slice
            .call(splideWrapper.children)
            .filter((child) => child.tagName === "A" || child.tagName === "BUTTON");
    if (options.perPage !== undefined && Components.Slides.get().length <= options.perPage) {
      if (Components.Arrows.destroy !== undefined) {
        Components.Arrows.destroy();
      }
      /** @type {HTMLElement | null} */
      const elm1 = track.querySelector(".splide__list");
      if (elm1 !== null) {
        elm1.style.justifyContent = "center";
      }
      return;
    }
    scrollWrapper = document.createElement("div");
    scrollWrapper.innerHTML = '<div class="splide-scrollbar-wrapper"><div class="scroll-thumb"></div></div>';
    scrollWrapper.classList.add("splide-custom-controls");
    if (splideWrapper !== null) {
      splideWrapper.insertBefore(scrollWrapper, track.nextSibling);
    }
    const moveArrows = () => {
      if (options.arrows && track.previousSibling && scrollWrapper !== null) {
        scrollWrapper.appendChild(track.previousSibling);
      }
    };
    moveArrows();
    Splide.on("arrows:mounted", moveArrows);
    Splide.on("arrows:updated", moveArrows);
    if (ctas.length > 0) {
      const ctasWrapper = document.createElement("div");
      ctasWrapper.classList.add("ctas-wrapper");
      for (const child of ctas) {
        ctasWrapper.appendChild(child);
      }
      scrollWrapper.appendChild(ctasWrapper);
    }
    /** @type {HTMLElement | null} */
    const scrollbar = scrollWrapper.querySelector(".scroll-thumb");
    /** @type {HTMLElement | null} */
    const scrollTrack = scrollWrapper.querySelector(".splide-scrollbar-wrapper");
    const itemsTotalWidth = getItemsWidth() - track.offsetWidth;
    if (scrollbar !== null) {
      scrollbar.addEventListener("mousedown", () => {
        scrollbar.classList.add("notrans");
        document.body.addEventListener("mousemove", onMouseDrag);
      });
    }
    document.body.addEventListener("mouseup", () => {
      if (scrollbar !== null) {
        scrollbar.classList.remove("notrans");
      }
      document.body.removeEventListener("mousemove", onMouseDrag);
    });
    const onMouseDrag = (/** @type {MouseEvent} */ event) => {
      if (scrollTrack === null) {
        console.error("No scroll track found");
        return;
      }
      if (scrollbar === null) {
        console.error("No scrollbar found");
        return;
      }
      const movementX = event.movementX;
      const trackWidth = scrollTrack.offsetWidth - scrollbar.offsetWidth;
      const getContainerStyle = globalThis.getComputedStyle(scrollbar);
      const leftValue = Number.parseInt(getContainerStyle.left, 10);
      const leftPosition1 = leftValue + movementX;
      const leftPosition2 = leftPosition1 < 0 ? 0 : leftPosition1;
      const leftPosition = leftPosition2 > trackWidth ? trackWidth : leftPosition2;
      const leftPercent = (leftValue / trackWidth) * 100;
      const leftScroll = itemsTotalWidth * (leftPercent / 100);
      scrollbar.style.left = `${leftPosition}px`;
      Splide.Components.Controller.scroll(-leftScroll, undefined, true);
    };
    updateScrollbar();
    Splide.on("moved", updateScrollbar);
  }

  function getItemsWidth() {
    const firstSlide = Components.Slides.get()[0].slide;
    const getGap = () => {
      if (options.gap === null || options.gap === undefined) {
        return 0;
      }
      if (typeof options.gap === "string") {
        const gapVal = options.gap;
        const matchGrp = gapVal.match(/\d+/);
        if (matchGrp === null) {
          return 0;
        }
        const matchNum = matchGrp[0];
        const matchInt = Number(matchNum);
        return matchInt;
      }
      return options.gap;
    };
    const itemsGap = getGap();
    return (firstSlide.offsetWidth + itemsGap) * Components.Slides.getLength() - itemsGap;
  }

  function getTranslateX(/** @type {HTMLElement} */ element) {
    const elmStyle = globalThis.getComputedStyle(element);
    const matrix = new WebKitCSSMatrix(elmStyle.transform);
    return matrix.m41 ? matrix.m41 * -1 : matrix.m42 * -1;
  }

  const updateScrollbar = () => {
    if (scrollWrapper === null) {
      throw new Error("No scroll wrapper found");
    }
    if (splideList === null) {
      throw new Error("No splide list found");
    }
    /** @type {HTMLElement | null} */
    const scrollbar = scrollWrapper.querySelector(".scroll-thumb");
    const itemsWidth = getItemsWidth();
    const slideProgress = getTranslateX(splideList);
    const totalWidth = (100 / itemsWidth) * track.offsetWidth;
    const positionPercentage = (100 / (itemsWidth - track.offsetWidth)) * slideProgress;
    const fixdPositionPercentage1 = (100 - totalWidth) * (positionPercentage / 100);
    const fixdPositionPercentage = fixdPositionPercentage1 < 0 ? 0 : fixdPositionPercentage1;
    if (scrollbar === null) {
      console.error("No scrollbar found");
    } else {
      scrollbar.style.width = `${totalWidth}%`;
      scrollbar.style.left = `${fixdPositionPercentage}%`;
    }
  };

  return {
    mount,
  };
}
